export default "__VITE_ASSET__1a34da65__"